import { render, staticRenderFns } from "./branding-details.vue?vue&type=template&id=eb0593b2&scoped=true&"
import script from "./branding-details.vue?vue&type=script&lang=js&"
export * from "./branding-details.vue?vue&type=script&lang=js&"
import style0 from "./branding-details.vue?vue&type=style&index=0&id=eb0593b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0593b2",
  null
  
)

component.options.__file = "branding-details.vue"
export default component.exports